import { PaymentConfigurationActions, PaymentConfigurationActionTypes } from './../actions/payment-configuration.action';
import { PaymentConfiguration } from './../../models/payment-configuration';


export interface State {
    paymentConfiguration: PaymentConfiguration | undefined;
}

export const initialState: State = {
    paymentConfiguration: undefined
};

export function reducer(state = initialState, action: PaymentConfigurationActions): State {
    switch (action.type) {
        case PaymentConfigurationActionTypes.CLEAR_PAYMENT_CONFIGURATION: {
            return initialState;
        }

        case PaymentConfigurationActionTypes.LOAD_PAYMENT_CONFIGURATION: {
            return state;
        }

        case PaymentConfigurationActionTypes.ADD_PAYMENT_CONFIGURATION: {
            return { ...state, paymentConfiguration: action.payload };
        }

        default: {
            return state;
        }
    }
}

export const getPaymentConfiguration = (state: State) => state && state.paymentConfiguration;
